import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BH_MOTIF_ABSENCE_OPTIONS } from '../../../bh-qrcode-site-scanner.model';
import { startWith, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'md-bh-qrcode-site-scanner-motif-dialog',
    templateUrl: './md-bh-qrcode-site-scanner-motif-dialog.component.html',
})
export class MdBhQrCodeSiteScannerMotifDialog implements OnInit {

    BH_MOTIF_ABSENCE_OPTIONS = BH_MOTIF_ABSENCE_OPTIONS;
    dateControle: any;
    site: any;
    agent: any;
    presence: boolean;
    allAgents: any[] = [];
    agentsFiltered: any[] = [];
    searchFormControl = new FormControl('');
    motifFormGroup = this.formBuilder.group({
        MOTIF_ABSENCE: new FormControl(null, [Validators.required]),
        AGENT_REPLACANT_ID: new FormControl(null),
        AGENT_REPLACANT_FULLNAME: new FormControl(null),
        COMMENTAIRES: new FormControl(null),
    });
    readonly = false;
    
    constructor(
        public dialogRef: MatDialogRef<MdBhQrCodeSiteScannerMotifDialog>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) data: { 
            dateControle: any, 
            site: any, 
            agent: any, 
            presence: boolean, 
            allAgents: any[], 
            motif: any,
            readonly?: boolean 
        },
    ) {
        this.dateControle = data.dateControle;
        this.site = data.site;
        this.agent = data.agent;
        this.presence = data.presence;
        this.allAgents = data.allAgents;
        this.agentsFiltered = this.allAgents;
        this.readonly = !!data.readonly && data.readonly === true;
        if (!!data.motif) {
            this.motifFormGroup.patchValue({
                MOTIF_ABSENCE: data.motif.MOTIF_ABSENCE,
                AGENT_REPLACANT_ID: data.motif.AGENT_REPLACANT_ID,
                AGENT_REPLACANT_FULLNAME: data.motif.AGENT_REPLACANT_FULLNAME,
                COMMENTAIRES: data.motif.COMMENTAIRES,
            });
        }
    }

    ngOnInit() {
        this.searchFormControl.valueChanges.pipe(
            startWith(''),
            debounceTime(400),
            distinctUntilChanged(),
        ).subscribe(async searchValue => {
            this.agentsFiltered = this.allAgents.filter(
                a => !!a && !!a.FULLNAME && a.FULLNAME.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
            );
        });
    }

    get f() {
        return this.motifFormGroup.controls;
    }
    
    dismiss() {
        this.dialogRef.close();
    }

    onSubmit() {
        if (this.motifFormGroup.invalid || this.readonly) { return; }

        const agentReplacant = this.allAgents.find(a => a.ID === this.motifFormGroup.get('AGENT_REPLACANT_ID')?.value);
        const data = {
            MOTIF_ABSENCE: this.motifFormGroup.get('MOTIF_ABSENCE')?.value,
            AGENT_REPLACANT_ID: agentReplacant?.ID,
            AGENT_REPLACANT_FULLNAME: agentReplacant?.FULLNAME,
            COMMENTAIRES: this.motifFormGroup.get('COMMENTAIRES')?.value,
        };
        this.dialogRef.close(data);
    }
}